import React, { useState, useEffect } from "react";
import "./Map.css";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const Map = () => {
  const [liveLocation, setLiveLocation] = useState(null);
  const [heading, setHeading] = useState(0);
  const [Timestamp, setTimestamp] = useState("");
  const [accuracy, setAccuracy] = useState(0);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch(
          "https://getlocation-x2bsaejaeq-as.a.run.app"
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const apiResponse = await response.json();
        const data = apiResponse.data;

        if (data.coords) {
          setLiveLocation({
            lat: data.coords.latitude,
            lng: data.coords.longitude,
          });
        }

        if (data.updatedAt) {
          const updatedAtTime = new Date(data.updatedAt).toLocaleTimeString();
          setTimestamp(updatedAtTime);
        } else {
        }

        if (data.coords?.heading) {
          setHeading(data.coords.heading);
        }

        if (data.coords?.accuracy) {
          setAccuracy(data.coords.accuracy);
        }

      } catch (error) {
      }
    };

    fetchLocation();
    const interval = setInterval(fetchLocation, 30000);
    return () => clearInterval(interval);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "500px",
  };

  const defaultCenter = { lat: 51.5074, lng: -0.1278 };
  const center = liveLocation || defaultCenter;

  const rotateSVG = (heading) => {
    return `
            <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg">
                <g transform="rotate(${heading}, 25, 25)">
<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 137.36 279.18">
  <defs>
    <style>
      .cls-1 {
        fill: #010101;
      }

      .cls-2 {
        fill: #333;
      }

      .cls-3, .cls-4 {
        fill: #bf2026;
      }

      .cls-5 {
        fill: #cd6d28;
      }

      .cls-6 {
        fill: #d9d9d8;
      }

      .cls-4, .cls-7, .cls-8, .cls-9 {
        stroke: #010101;
      }

      .cls-4, .cls-7, .cls-8, .cls-9, .cls-10 {
        stroke-miterlimit: 10;
        stroke-width: .5px;
      }

      .cls-11 {
        fill: url(#Degradado_sin_nombre-19);
      }

      .cls-12 {
        fill: url(#Degradado_sin_nombre-18);
      }

      .cls-13 {
        fill: url(#Degradado_sin_nombre-13);
      }

      .cls-14 {
        fill: url(#Degradado_sin_nombre-12);
      }

      .cls-15 {
        fill: url(#Degradado_sin_nombre-15);
      }

      .cls-16 {
        fill: url(#Degradado_sin_nombre-14);
      }

      .cls-17 {
        fill: url(#Degradado_sin_nombre-17);
      }

      .cls-18 {
        fill: url(#Degradado_sin_nombre-16);
      }

      .cls-19 {
        fill: url(#Degradado_sin_nombre-11);
      }

      .cls-20 {
        fill: url(#Degradado_sin_nombre-10);
      }

      .cls-21 {
        fill: url(#Degradado_sin_nombre-20);
      }

      .cls-22 {
        fill: url(#Degradado_sin_nombre-9);
      }

      .cls-23 {
        fill: url(#Degradado_sin_nombre-8);
      }

      .cls-24 {
        fill: url(#Degradado_sin_nombre-7);
      }

      .cls-25 {
        fill: url(#Degradado_sin_nombre-6);
      }

      .cls-26 {
        fill: url(#Degradado_sin_nombre-5);
      }

      .cls-27 {
        fill: url(#Degradado_sin_nombre-3);
      }

      .cls-28 {
        fill: url(#Degradado_sin_nombre-2);
      }

      .cls-7 {
        fill: url(#Degradado_sin_nombre-4);
      }

      .cls-8 {
        fill: url(#Degradado_sin_nombre-21);
      }

      .cls-29 {
        fill: url(#Degradado_sin_nombre);
      }

      .cls-9, .cls-10 {
        fill: none;
      }

      .cls-10 {
        stroke: #bf2026;
      }
    </style>
    <linearGradient id="Degradado_sin_nombre" data-name="Degradado sin nombre" x1="38.43" y1="126.38" x2="18.24" y2="123.93" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#fff"/>
      <stop offset="1" stop-color="#000"/>
    </linearGradient>
    <linearGradient id="Degradado_sin_nombre-2" data-name="Degradado sin nombre" x1="39.3" y1="189.71" x2="15.13" y2="193.08" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-3" data-name="Degradado sin nombre" x1="18.09" y1="236.95" x2="31.19" y2="236.95" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-4" data-name="Degradado sin nombre" x1="30.77" y1="23.25" x2="24.66" y2="10.61" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-5" data-name="Degradado sin nombre" x1="68.41" y1="107.93" x2="68.44" y2="107.93" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-6" data-name="Degradado sin nombre" x1="-14.08" y1="90.45" x2="104.29" y2="87.09" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-7" data-name="Degradado sin nombre" x1="68.41" y1="107.26" x2="68.44" y2="107.26" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-8" data-name="Degradado sin nombre" x1="68.32" y1="64.72" x2="68.54" y2="64.72" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-9" data-name="Degradado sin nombre" x1="3511.95" y1="126.38" x2="3491.76" y2="123.93" gradientTransform="translate(3610.88) rotate(-180) scale(1 -1)" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-10" data-name="Degradado sin nombre" x1="100.13" y1="191.8" x2="119.4" y2="192.72" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-11" data-name="Degradado sin nombre" x1="3491.61" y1="236.95" x2="3504.71" y2="236.95" gradientTransform="translate(3610.88) rotate(-180) scale(1 -1)" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-12" data-name="Degradado sin nombre" x1="68.42" y1="271.85" x2="68.42" y2="271.85" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-13" data-name="Degradado sin nombre" x1="68.38" y1="271.85" x2="68.38" y2="271.85" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-14" data-name="Degradado sin nombre" x1="68.34" y1="271.85" x2="68.34" y2="271.85" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-15" data-name="Degradado sin nombre" x1="68.48" y1="271.85" x2="68.48" y2="271.85" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-16" data-name="Degradado sin nombre" x1="69.6" y1="237.58" x2="68.56" y2="268.53" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-17" data-name="Degradado sin nombre" x1="68.44" y1="271.85" x2="68.44" y2="271.85" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-18" data-name="Degradado sin nombre" x1="68.51" y1="271.85" x2="68.51" y2="271.85" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-19" data-name="Degradado sin nombre" x1="-3.7" y1="170.26" x2="97.23" y2="171.17" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-20" data-name="Degradado sin nombre" x1="68.84" y1="7.25" x2="68.63" y2="-2.28" xlink:href="#Degradado_sin_nombre"/>
    <linearGradient id="Degradado_sin_nombre-21" data-name="Degradado sin nombre" x1="3504.29" y1="23.25" x2="3498.17" y2="10.61" gradientTransform="translate(3610.88) rotate(-180) scale(1 -1)" xlink:href="#Degradado_sin_nombre"/>
  </defs>
  <g id="Layer_1-2" data-name="Layer 1">
    <g>
      <path class="cls-3" d="m119.18,225.98c.32-5.75,1.07-18.5,1.06-22.34s.07-22.87.15-43.99c.01,0,.02,0,.03,0,0,1.39,0,5.03.03-.65,2.2-.74,4.55-3.08,6.97-2.37-.05,20.17-.09,49.43-.09,63.13-2.39,4.58-4.96,6.15-8.14,6.22Z"/>
      <path class="cls-3" d="m126.01,79.14c0,.33,0,.66,0,.96.06,19.13,1.46,57.6,1.41,76.52-2.42-.71-4.56,1.32-6.97,2.26.11-28.5.21-72.5.22-76.87-.08-.66-.13-2.05-.15-3.46,1.84.12,3.96-.25,5.49.58Z"/>
      <path class="cls-3" d="m18.18,225.98c-.32-5.75-1.07-18.5-1.06-22.34s-.07-22.87-.15-43.99c-.01,0-.02,0-.03,0,0,1.39,0,5.03-.03-.65-2.2-.74-4.55-3.08-6.97-2.37.05,20.17.09,49.43.09,63.13,2.39,4.58,4.96,6.15,8.14,6.22Z"/>
      <path class="cls-3" d="m11.36,79.14c0,.33,0,.66,0,.96-.06,19.13-1.46,57.6-1.41,76.52,2.42-.71,4.56,1.32,6.97,2.26-.11-28.5-.21-72.5-.22-76.87.08-.66.13-2.05.15-3.46-1.84.12-3.96-.25-5.49.58Z"/>
      <path class="cls-1" d="m119.58,71.47c-.08-3.03-.92-5.62-4.73-8.47-3.82-2.86-10.87-4.75-18.6-6.18-9.8-1.81-26.27-1.66-27.71-1.64.03,0,.03,0-.1,0-.13,0-.13,0-.11,0-1.44-.02-17.42-.17-27.2,1.64-7.73,1.43-14.78,3.32-18.6,6.18-3.82,2.86-4.66,5.45-4.73,8.47-.1,3.81,9.4,43.76,9.4,43.76,0,0,7.31-2.77,18.42-3.77,8.75-.79,21.89-.96,22.77-.97-.07,0-.18,0,.05,0,.23,0,.11,0,.04,0,.83,0,14.51.17,23.29.97,11.11,1.01,18.42,3.77,18.42,3.77,0,0,9.49-39.95,9.4-43.76Z"/>
      <path class="cls-3" d="m112.9,114.5c.02-1.97-.83-4.13-1.38-4.85-.67,2.44-1.34,5.59-1.34,5.59,0,0-7.31-2.77-18.42-3.77-8.31-.75-21.3-.94-23.33-.97.32,0,.96.02,0,.04-.96-.02-.32-.03,0-.04-2.03.03-14.51.22-22.82.97-11.11,1.01-18.42,3.77-18.42,3.77,0,0-.66-3.19-1.14-5.77-.56.72-1.5,2.81-1.76,4.61.49,1.94,1,4.3,1,6.24.82,28.96,2.85,57.71,1.63,86.67-.1.62-.42,1.24-.78,1.89.26,6.26.81,14.11,1.47,19.34.34,2.68.55,6.01.81,9.35l40.01-.59,40.52.59c.26-3.33.47-6.67.81-9.35.67-5.23,1.21-13.08,1.47-19.34-.36-.65-.68-1.27-.78-1.89-1.22-28.96.82-57.71,1.63-86.67,0-1.94.33-3.87.82-5.81Z"/>
      <path class="cls-3" d="m126,43.02c-.84-8.91-.94-9.28-2.77-15.02-1.83-5.75-6.46-12.64-16.38-19.93C96.2.25,73.3,0,68.55.01c-4.75,0-27.39.24-38.04,8.06-9.92,7.28-14.55,14.18-16.38,19.93-1.83,5.75-1.93,6.11-2.77,15.02-.57,6.07-.02,26.4,0,36.12,1.53-.83,3.65-.46,5.49-.58.03-1.77.04-3.58.04-4.06,0-3.81,1.82-8.64,5.64-11.5,3.82-2.86,10.87-4.75,18.6-6.18,8.28-1.53,27.31-1.64,27.31-1.64,0,0,19.53.11,27.81,1.64,7.73,1.43,14.78,3.32,18.6,6.18,3.82,2.86,5.64,7.69,5.64,11.5,0,.48,0,2.29.04,4.06,1.84.12,3.96-.25,5.49.58.01-9.72.57-30.05,0-36.12ZM68.55.02c-.06,0-.03,0,0,0,.03,0,.06,0,0,0Z"/>
      <path class="cls-3" d="m22.29,257.31c-1.96-5.6-2.78-13.43-3.34-17.73-.42-3.27-.2-5.07-.81-13.57-2.65-.05-5.49-1-8.11-5.85.15,3.42.18,6.05.15,7.42-.15,5.73.08,10.19.82,18.45.71,7.87,2.45,16.22,5.86,20.67.17.22.33.44.51.64.39.44.85.87,1.36,1.3,1.16-3.69,2.38-7.39,3.62-11.08-.04-.13-.07-.23-.06-.25Z"/>
      <path class="cls-1" d="m33.65,245.6c11.73,3.16,22.82,2.69,34.77,2.23v-11.2l-39.97.56c.13,3.73,1.27,7.35,5.2,8.41Z"/>
      <path class="cls-9" d="m16.84,78.56c-1.84.12-3.96-.25-5.49.58"/>
      <path class="cls-9" d="m9.94,156.63c2.42-.71,4.74,1.52,7.15,2.47"/>
      <path class="cls-5" d="m11.3,72.37l-.24.02s-.51.88-.51,1.73.41,1.84.41,1.84h.38c0-1.13-.02-2.33-.04-3.58Z"/>
      <path class="cls-10" d="m68.43,110.49c.18,0,0,0,0,0,0,0,.14,0,0,0Z"/>
      <path class="cls-9" d="m10.04,219.76c2.46,5.51,5.39,5.98,8.04,6.19"/>
      <path class="cls-10" d="m24.75,161.51s.1,0,.15.01c-.05-.02-.1-.05-.15-.07,0,.02,0,.04,0,.06Z"/>
      <path class="cls-4" d="m24.92,161.53c.51,20.53,1.05,37.59,1.05,40.69,0,1.74.06,4.06.16,6.65.36-.65.68-1.27.78-1.89.63-15.02.39-29.98-.1-44.94-.63-.07-1.26-.22-1.89-.51Z"/>
      <path class="cls-4" d="m25.28,120.31c0-1.94-.48-4.25-.98-6.18-.13,1.01-.31,2.38-.31,3.62,0,2.19.35,26.5.76,43.7.05.02.1.05.15.07,0,0,0,0,.01,0,0,0,0,0,0,0,.63.29,1.26.44,1.89.51-.46-13.89-1.13-27.79-1.53-41.73Z"/>
      <path class="cls-10" d="m68.43,271.85h0c.1,0,.18,0,0,0Z"/>
      <path class="cls-1" d="m22.35,257.56c-1.23,3.69-2.46,7.39-3.62,11.08.06.05.12.1.18.15l3.52-10.98c-.03-.09-.06-.17-.09-.25Z"/>
      <path class="cls-10" d="m68.43,271.85h0c-.34,0-.14,0,0,0Z"/>
      <g>
        <path class="cls-10" d="m21.77,95.3c-.06-.21-.11-.42-.17-.63.06.21.11.42.17.63Z"/>
        <path class="cls-29" d="m26.08,109.43c-.96-3.5-1.84-6.72-3.04-12.3.03.14.03.18.06.32-1.48-1.01-3.8-2.36-5.28-3.37l-1.13-.33s.14,27.09.25,56.2c2.08,2.21,5.29,4.8,7.89,4.74-.45-17.93-.86-34.58-.86-36.94,0-3.16.84-6.86,2.11-8.32Z"/>
      </g>
      <path class="cls-1" d="m16.94,149.95c0,.78,0,8.8,0,9.57,2.64.56,5.44,1.89,7.94,2-.02-.82-.04-6.02-.06-6.83-2.6.06-5.81-2.64-7.89-4.74Z"/>
      <path class="cls-28" d="m19.98,223.49c1.84-4.08,3.67-7.95,5.3-11.83.33-.65.61-1.33.86-2.01-.13-2.9-.2-5.51-.2-7.43,0-3.11-.53-20.16-1.05-40.7-2.5-.11-5.3-1.44-7.94-2,.09,22.54.17,40.01.17,44.12,0,5.43.45,14.51.97,22.32,1.08-.23,1.55-1.63,1.89-2.47Z"/>
      <path class="cls-27" d="m27.58,228.21c-.64-5.01-1.17-12.44-1.44-18.55-.25.69-.53,1.36-.86,2.01-1.63,3.87-3.47,7.75-5.3,11.83-.34.84-.81,2.24-1.89,2.47.39,5.9.27,10.58.58,12.94.71,5.48,1.33,17.39,6.01,22.43,1.16,1.25,2.17,2.06,3.01,2.91l3.5-12.81c-2.18-3.6-2.69-15.95-3.62-23.22Z"/>
      <path class="cls-3" d="m25.59,230.75c-.5-6.52-1.42-10.19-1.48-16.37-1.32,2.98-2.31,4.69-3.72,7.82-.32.8-1.24,2.48-1.72,3.44.12,4.63.66,11.68.76,13.6.41,8.16,3,16.54,3,16.54,0,0,1.71-3.11,3.14-9.46,1.44-6.36.37-10.98.02-15.57Z"/>
      <path class="cls-1" d="m31.33,251.62c-.05-.06-.09-.13-.13-.19l-3.5,12.81c.42.42.55.32.99.65l3.94-11.76c-.37-.33-1.01-1.15-1.29-1.51Z"/>
      <path class="cls-7" d="m21.25,25.74c2.15-5.46,6.22-9.95,10.73-13.7,1.89-1.58,3.9-3.05,6.16-4.04.05-.27.12-.53.23-.78.31-.65,1-1.29.73-1.72-.26-.41-2.19.2-3.27.77-7.42,3.86-13.22,9.92-16.74,17.51-.53,1.14-.91,2.16-1.09,3.4-.32,2.25.34,4.88,1.23,7.2.36-2.95.92-5.88,2.01-8.64Z"/>
      <path class="cls-3" d="m17.7,266.35c-.37-.77-.62-1.63-1.25-2.2-.35-.32-.87-.47-1.33-.42.52,1.12,1.1,2.12,1.75,2.97.17.22.33.44.51.64,1.15,1.28,2.84,2.55,4.92,3.75-1.85-1.27-3.64-2.72-4.6-4.74Z"/>
      <path class="cls-1" d="m33.32,139.38s2.22,73.45,2.84,81.6c.61,8.16,1.43,12.85.61,13.66s-2.45-.2-3.47-2.65-3.53-33.99-3.4-48.67-1.22-52.2-1.22-56.69,1.29-9.79,1.9-10.81,1.93-2.35,2.24-1.02c.48,2.04-.07,6.39-.07,12.24,0,3.67.56,12.34.56,12.34Z"/>
      <path class="cls-2" d="m12.97,94.91L.05,99.84c.03.21.08.42.14.63.09.29.39.45.68.35,4.03-1.34,7.55-2.57,11.61-4.19.18-.07.35-.17.47-.32.13-.15.19-.31.21-.47-.03,0-.07,0-.13,0,.06,0,.1,0,.13,0,.04-.3-.07-.61-.21-.93Z"/>
      <path class="cls-2" d="m16.73,80.48c-2.28,3.2-3.18,3.71-6.13,6.96-.79.87-1.82,1.82-2.89,2.76,1.24-.2,2.54.03,3.71.73.7.6,1.1,1.4,1.36,2.27.32-.45,1.1-.5,1.92-.48,1.15.02,1.18.45,2.13,1.1,1.48,1.01,6.15,3.42,6.15,3.42,0,0-1.29-6.05-1.59-7.42-.44-2.03-3.49-20.49-3.49-20.49,0,0-1.33,2.41-1.17,11.13Z"/>
      <path class="cls-1" d="m11.41,90.94c-1.17-.7-2.47-.93-3.71-.73-1.64,1.44-3.41,2.88-4.73,4.09-1.87,1.72-3.27,3.35-2.92,5.54l12.91-4.93c-.13-.31-.28-.64-.32-.95-.05-.32,0-.56.13-.74-.26-.87-.66-1.67-1.36-2.27Z"/>
      <path class="cls-6" d="m10.95,140.38c0-.17.11-.34-.07-.31-.83.14-1.83,1.62-2,3.1-.15,1.31-.29,2.41-.17,3.72.17,1.85.71,3.57,1.79,5.06.14.2.45.09.46-.15.02-1.58,0-1,.01-2.5-1.25-1.04-1.77-3.53-1.26-5.07.22-.68.57-1.97,1.27-1.86l-.03-2Z"/>
      <path class="cls-6" d="m11.63,200.2c0-.17.11-.34-.07-.31-.83.14-1.83,1.62-2,3.1-.15,1.31-.29,2.41-.17,3.72.17,1.85.71,3.57,1.79,5.06.14.2.45.09.46-.15.02-1.58,0-1,.01-2.5-1.25-1.04-1.77-3.53-1.26-5.07.22-.68.57-1.97,1.27-1.86l-.03-2Z"/>
      <path class="cls-3" d="m115.07,257.31c1.96-5.6,2.78-13.43,3.34-17.73.42-3.27.2-5.07.81-13.57,2.65-.05,5.49-1,8.11-5.85-.15,3.42-.18,6.05-.15,7.42.15,5.73-.08,10.19-.82,18.45-.71,7.87-2.45,16.22-5.86,20.67-.17.22-.33.44-.51.64-.39.44-.85.87-1.36,1.3-1.16-3.69-2.38-7.39-3.62-11.08.04-.13.07-.23.06-.25Z"/>
      <path class="cls-1" d="m103.71,245.6c-11.73,3.16-23.32,2.69-35.28,2.23v-11.2l40.48.56c-.13,3.73-1.27,7.35-5.2,8.41Z"/>
      <path class="cls-9" d="m120.52,78.56c1.84.12,3.96-.25,5.49.58"/>
      <path class="cls-5" d="m126.06,72.37l.24.02s.51.88.51,1.73-.41,1.84-.41,1.84h-.38c0-1.13.02-2.33.04-3.58Z"/>
      <path class="cls-10" d="m68.43,110.49c-.18,0,0,0,0,0,0,0-.14,0,0,0Z"/>
      <path class="cls-9" d="m127.33,219.76c-2.46,5.51-5.39,5.98-8.04,6.19"/>
      <path class="cls-4" d="m68.43,236.97l-35.37.52c.11,3.48,1.13,6.85,4.61,7.85,10.39,2.95,20.11,4.93,30.71,4.5,10.6.43,20.93-1.55,31.32-4.5,3.48-.99,4.49-4.36,4.61-7.85l-35.87-.52Z"/>
      <path class="cls-4" d="m104.57,237.49c-.11,3.48-1.04,7.03-4.51,8.03-10.39,2.95-21.03,5.01-31.62,4.58-10.6.43-20.72-1.63-31.12-4.58-3.48-.99-4.4-4.54-4.51-8.03l-4.38.06c.45,5.71,1.06,11.42,2.8,13.88.04.06.09.13.13.19.29.36.93,1.18,1.29,1.51,3.3,2.99,10.97,6.45,18.12,7.89,6.45,1.3,16.74,1.43,17.66,1.43.92,0,11.71-.13,18.16-1.43,7.15-1.44,14.82-4.9,18.12-7.89.37-.33,1.01-1.15,1.29-1.51.05-.06.09-.13.13-.19,1.74-2.46,2.36-8.17,2.8-13.88l-4.38-.06Z"/>
      <path class="cls-10" d="m112.61,161.51s-.1,0-.15.01c.05-.02.1-.05.15-.07,0,.02,0,.04,0,.06Z"/>
      <path class="cls-4" d="m112.45,161.53c-.51,20.53-1.05,37.59-1.05,40.69,0,1.74-.06,4.06-.16,6.65-.36-.65-.68-1.27-.78-1.89-.63-15.02-.39-29.98.1-44.94.63-.07,1.26-.22,1.89-.51Z"/>
      <path class="cls-4" d="m112.08,120.31c0-1.94.48-4.25.98-6.18.13,1.01.31,2.38.31,3.62,0,2.19-.35,26.5-.76,43.7-.05.02-.1.05-.15.07,0,0,0,0-.01,0,0,0,0,0,0,0-.63.29-1.26.44-1.89.51.46-13.89,1.13-27.79,1.53-41.73Z"/>
      <path class="cls-10" d="m68.43,271.85h0c-.1,0-.18,0,0,0Z"/>
      <path class="cls-1" d="m115.01,257.56c1.23,3.69,2.46,7.39,3.62,11.08-.06.05-.12.1-.18.15l-3.52-10.98c.03-.09.06-.17.09-.25Z"/>
      <path class="cls-3" d="m118.54,268.69l-3.52-10.98c-.17.29-.26.51-.37.71-.82,1.48-1.21,2.06-1.99,2.99-1.09,1.31-2.14,2-2.99,2.84-.42.42-.55.32-.99.65-1.6,1.21-4.24,1.94-6.73,2.99-5.4,2.28-14.09,3.25-21,3.74-3.62.25-10.13.17-12.52.23.34,0,.14,0,0,0-.14,0-.34,0,0,0-2.4-.06-8.4.02-12.02-.23-6.91-.48-15.6-1.46-21-3.74-2.49-1.05-5.12-1.79-6.73-2.99-.43-.33-.56-.23-.99-.65-.85-.84-1.9-1.52-2.99-2.84-.77-.93-1.17-1.51-1.99-2.99-.11-.2-.2-.42-.37-.71l-3.52,10.98c5.53,4.56,16.97,8.56,28.18,9.56,5.08.45,14.81.73,21.37.93,0,0,.02,0,.06,0,.05,0,.06,0,.06,0,6.56-.19,16.8-.47,21.87-.93,11.21-1,22.64-4.99,28.18-9.56Zm-50.12,10.48c-.06,0-.11,0,0-.01.11,0,.06,0,0,.01Z"/>
      <path class="cls-10" d="m68.43,271.85h0c.34,0,.14,0,0,0Z"/>
      <g>
        <path class="cls-26" d="m68.43,108.27s.01-.34,0-.67c-.01.34-.03.67,0,.67Z"/>
        <path class="cls-25" d="m113.05,70.78c-3.61-1.29-9.4-2.43-15.58-3.29-10.82-1.51-21.76-2.56-29.06-2.55-7.17,0-17.69,1.04-28.52,2.55-6.17.86-11.97,1.99-15.58,3.29-1.07.38-1.7,1.49-1.48,2.6.41,2.09,1.01,5.18,1.08,5.53,1.22,5.61,3.62,20.78,6.1,29.79.31,1.13,1.48,1.79,2.6,1.48,2.57-.73,6-1.29,12.51-2.04,9.59-1.1,14.46-1.26,23.3-1.22,8.84-.03,14.21.12,23.81,1.22,6.51.75,9.94,1.31,12.51,2.04,1.12.32,2.29-.35,2.6-1.48,2.48-9.01,4.88-24.18,6.1-29.79.08-.36.68-3.44,1.08-5.53.22-1.12-.41-2.22-1.48-2.6Z"/>
        <path class="cls-24" d="m68.43,107.6c.01-.34.03-.68,0-.68-.03,0-.01.34,0,.68Z"/>
        <path class="cls-23" d="m68.43,64.72c-.24,0,0,0,0,0,0,0,.24,0,0,0Z"/>
      </g>
      <g>
        <path class="cls-10" d="m115.6,95.3c.06-.21.11-.42.17-.63-.06.21-.11.42-.17.63Z"/>
        <path class="cls-22" d="m111.37,109.65c.96-3.5,1.75-6.94,2.95-12.52-.03.14-.03.18-.06.32,1.48-1.01,3.8-2.36,5.28-3.37l1.13-.33s-.14,27.09-.25,56.2c-2.08,2.21-5.29,4.8-7.89,4.74.45-17.93.86-34.58.86-36.94,0-3.16-.75-6.64-2.02-8.1Z"/>
      </g>
      <path class="cls-1" d="m120.42,149.95c0,.78,0,8.8,0,9.57-2.64.56-5.44,1.89-7.94,2,.02-.82.04-6.02.06-6.83,2.6.06,5.81-2.64,7.89-4.74Z"/>
      <path class="cls-20" d="m117.39,223.49c-1.84-4.08-3.67-7.95-5.3-11.83-.33-.65-.61-1.33-.86-2.01.13-2.9.2-5.51.2-7.43,0-3.11.53-20.16,1.05-40.7,2.5-.11,5.3-1.44,7.94-2-.09,22.54-.17,40.01-.17,44.12,0,5.43-.45,14.51-.97,22.32-1.08-.23-1.55-1.63-1.89-2.47Z"/>
      <path class="cls-19" d="m109.79,228.21c.64-5.01,1.17-12.44,1.44-18.55.25.69.53,1.36.86,2.01,1.63,3.87,3.47,7.75,5.3,11.83.34.84.81,2.24,1.89,2.47-.39,5.9-.27,10.58-.58,12.94-.71,5.48-1.33,17.39-6.01,22.43-1.16,1.25-2.17,2.06-3.01,2.91l-3.5-12.81c2.18-3.6,2.69-15.95,3.62-23.22Z"/>
      <path class="cls-3" d="m111.78,230.75c.5-6.52,1.42-10.19,1.48-16.37,1.32,2.98,2.31,4.69,3.72,7.82.32.8,1.24,2.48,1.72,3.44-.12,4.63-.66,11.68-.76,13.6-.41,8.16-3,16.54-3,16.54,0,0-1.71-3.11-3.14-9.46-1.44-6.36-.37-10.98-.02-15.57Z"/>
      <path class="cls-1" d="m106.04,251.62c.05-.06.09-.13.13-.19l3.5,12.81c-.42.42-.55.32-.99.65l-3.94-11.76c.37-.33,1.01-1.15,1.29-1.51Z"/>
      <g>
        <path class="cls-14" d="m68.43,271.85s0,0-.02,0c0,0,.01,0,.02,0Z"/>
        <path class="cls-13" d="m68.41,271.85s-.05,0-.06,0c.01,0,.04,0,.06,0Z"/>
        <path class="cls-16" d="m68.35,271.85s0,0,0,0h0Z"/>
        <path class="cls-15" d="m68.45,271.85s.05,0,.06,0c0,0-.03,0-.06,0Z"/>
        <path class="cls-18" d="m104.74,253.13c-3.3,2.99-10.65,6.33-17.8,7.77-6.81,1.37-18.51,1.44-18.51,1.44h0s-11.19-.07-18.01-1.44c-7.15-1.44-14.5-4.79-17.8-7.77l-3.94,11.76c1.6,1.21,4.24,1.94,6.73,2.99,5.4,2.28,14.09,3.25,21,3.74,4.76.33,12.02.23,12.02.23,0,0,7.76.1,12.52-.23,6.91-.48,15.6-1.46,21-3.74,2.49-1.05,5.12-1.79,6.73-2.99l-3.94-11.76Z"/>
        <path class="cls-17" d="m68.43,271.85s.01,0,.02,0c-.01,0-.02,0-.02,0Z"/>
        <path class="cls-12" d="m68.51,271.85s0,0,0,0h0Z"/>
      </g>
      <path class="cls-1" d="m100.54,137.47c-2.23-1.59-3.82-5.72-5.73-8.26-1.91-2.54-3.82-3.17-9.22-3.49s-17.16-.3-17.16-.3c0,0-11.25-.01-16.66.3-5.4.31-7.31.95-9.22,3.49-1.91,2.54-3.5,6.67-5.73,8.26-2.23,1.59-3.5,1.9-3.5,1.9l2.16,63.93s.95.91,3.49,2.19c2.54,1.27,4.39,6.6,6.3,8.82,1.9,2.23,5.84,4.28,10.6,4.28,4.77,0,12.56.2,12.56.2,0,0,8.3-.2,13.07-.2,4.77,0,8.7-2.06,10.6-4.28,1.9-2.23,3.76-7.55,6.3-8.82,2.54-1.27,3.49-2.19,3.49-2.19l2.16-63.93s-1.27-.32-3.5-1.9Z"/>
      <path class="cls-11" d="m98.61,138.35c-2.09-1.49-3.59-5.38-5.39-7.76s-3.59-2.98-8.67-3.28c-5.08-.29-16.12-.28-16.12-.28,0,0-10.53-.01-15.62.28-5.08.29-6.88.89-8.67,3.28s-3.29,6.27-5.39,7.76c-2.09,1.49-3.29,1.79-3.29,1.79l2.03,60.12s.89.86,3.28,2.06c2.39,1.2,4.13,6.2,5.92,8.3,1.79,2.09,5.49,4.02,9.97,4.03,4.48,0,11.76.19,11.76.19,0,0,7.79-.19,12.27-.19,4.48,0,8.18-1.93,9.97-4.03,1.79-2.09,3.53-7.1,5.92-8.3,2.39-1.2,3.28-2.06,3.28-2.06l2.03-60.12s-1.2-.3-3.29-1.79Z"/>
      <path class="cls-21" d="m68.55.01c-1.01,0-2.45-.06-4.85.09.4.49,1.06.95,1.7,1.14.91.28,2.23.49,3.17.64.82-.06,2.56-.32,3.39-.64.62-.24,1.3-.65,1.7-1.14-2.4-.16-4.1-.09-5.11-.09Zm0,0s.06,0,0,0c-.06,0-.03,0,0,0Z"/>
      <path class="cls-4" d="m118.34,36.41c-.34-3.63-.89-7.28-2.23-10.67-2.15-5.46-6.22-9.95-10.73-13.7-1.92-1.6-3.95-3.09-6.25-4.07-2.83-1.21-7.41-2.15-10.77-2.71-6.93-1.16-14.87-1.75-19.85-1.75-4.9,0-12.58.59-19.51,1.75-3.37.56-7.94,1.5-10.77,2.71-2.29.98-4.33,2.48-6.25,4.07-4.51,3.75-8.58,8.25-10.73,13.7-1.34,3.39-1.88,7.04-2.23,10.67-.62,6.5-.61,13.04-.6,19.57,0,3.12.12,6.52,1.78,9.06.68-.71,1.46-1.39,2.32-2.03,3.82-2.86,10.87-4.75,18.6-6.18,8.28-1.53,27.31-1.64,27.31-1.64,0,0,19.53.11,27.81,1.64,7.73,1.43,14.78,3.32,18.6,6.18.86.64,1.63,1.32,2.32,2.03,1.66-2.53,1.78-5.94,1.78-9.06,0-6.53.01-13.07-.6-19.57Z"/>
      <path class="cls-8" d="m116.11,25.74c-2.15-5.46-6.22-9.95-10.73-13.7-1.89-1.58-3.9-3.05-6.16-4.04-.05-.27-.12-.53-.23-.78-.31-.65-1-1.29-.73-1.72.26-.41,2.19.2,3.27.77,7.42,3.86,13.22,9.92,16.74,17.51.53,1.14.91,2.16,1.09,3.4.32,2.25-.34,4.88-1.23,7.2-.36-2.95-.92-5.88-2.01-8.64Z"/>
      <path class="cls-3" d="m119.66,266.35c.37-.77.62-1.63,1.25-2.2.35-.32.87-.47,1.33-.42-.52,1.12-1.1,2.12-1.75,2.97-.17.22-.33.44-.51.64-1.15,1.28-2.84,2.55-4.92,3.75,1.85-1.27,3.64-2.72,4.6-4.74Z"/>
      <path class="cls-1" d="m104.04,139.38s-2.22,73.45-2.84,81.6-1.43,12.85-.61,13.66,2.45-.2,3.47-2.65c1.02-2.45,3.53-33.99,3.4-48.67-.14-14.68,1.22-52.2,1.22-56.69s-1.29-9.79-1.9-10.81-1.93-2.35-2.24-1.02c-.48,2.04.07,6.39.07,12.24,0,3.67-.56,12.34-.56,12.34Z"/>
      <path class="cls-2" d="m124.4,94.91l12.91,4.93c-.03.21-.08.42-.14.63-.09.29-.39.45-.68.35-4.03-1.34-7.55-2.57-11.61-4.19-.18-.07-.35-.17-.47-.32-.13-.15-.19-.31-.21-.47.03,0,.07,0,.13,0-.06,0-.1,0-.13,0-.04-.3.07-.61.21-.93Z"/>
      <path class="cls-2" d="m120.63,80.48c2.28,3.2,3.18,3.71,6.13,6.96.79.87,1.82,1.82,2.89,2.76-1.24-.2-2.54.03-3.71.73-.7.6-1.1,1.4-1.36,2.27-.32-.45-1.1-.5-1.92-.48-1.15.02-1.18.45-2.13,1.1-1.48,1.01-6.15,3.42-6.15,3.42,0,0,1.29-6.05,1.59-7.42.44-2.03,3.49-20.49,3.49-20.49,0,0,1.33,2.41,1.17,11.13Z"/>
      <path class="cls-1" d="m125.95,90.94c1.17-.7,2.47-.93,3.71-.73,1.64,1.44,3.41,2.88,4.73,4.09,1.87,1.72,3.27,3.35,2.92,5.54l-12.91-4.93c.13-.31.28-.64.32-.95.05-.32,0-.56-.13-.74.26-.87.66-1.67,1.36-2.27Z"/>
      <path class="cls-6" d="m126.41,140.38c0-.17-.11-.34.07-.31.83.14,1.83,1.62,2,3.1.15,1.31.29,2.41.17,3.72-.17,1.85-.71,3.57-1.79,5.06-.14.2-.45.09-.46-.15-.02-1.58,0-1-.01-2.5,1.25-1.04,1.77-3.53,1.26-5.07-.22-.68-.57-1.97-1.27-1.86l.03-2Z"/>
      <path class="cls-6" d="m125.73,200.2c0-.17-.11-.34.07-.31.83.14,1.83,1.62,2,3.1.15,1.31.29,2.41.17,3.72-.17,1.85-.71,3.57-1.79,5.06-.14.2-.45.09-.46-.15-.02-1.58,0-1-.01-2.5,1.25-1.04,1.77-3.53,1.26-5.07-.22-.68-.57-1.97-1.27-1.86l.03-2Z"/>
      <path class="cls-9" d="m127.56,156.83c-2.62-.77-4.93,1.43-7.54,2.45"/>
    </g>
  </g>
</svg>
</g>
            </svg>
        `;
  };

  const svgMarker = rotateSVG(heading);

  return (
    <div>
      <div className="map-header">
        <p>
          Last Updated: <span>{Timestamp}</span>
        </p>
        {/* <p>
          Accuracy: <span>±{accuracy.toFixed(2)}m</span>
        </p> */}
      </div>
      <div className="map-container">
        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        >
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={16}
            options={{
              mapTypeControl: false,
              streetViewControl: false,
              zoomControl: false,
              cameraControl: false,
            }}
          >
            {liveLocation && (
              <Marker
                position={center}
                icon={{
                  url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
                    svgMarker
                  )}`,
                  scaledSize: { width: 40, height: 40 },
                  anchor: { x: 25, y: 50 },
                }}
              />
            )}
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  );
};

export default Map;
